export const BACKGROUND_COLOR = '#EEEEEE';

export const CARTED_CHAIR_COLOR = '#FEFEFE';

export const DEFAULT_COLOR = '#DBDAE3';
export const DEFAULT_FONT_SIZE = 20;
export const DEFAULT_STROKE = '#808080';
export const DEFAULT_STROKE_WIDTH = 0.07;

export const FONT_COLOR_LIGHT = '#FFFFFF';
export const FONT_COLOR_DARK = '#13002D';
// Threshold to consider a color to be dark or light. We will look at
// the max coordinate
export const FONT_COLOR_THRESHOLD = 0.5;
export const FONT_DEFAULT_COLOR = '#13002D';
export const FONT_GAMMA_ZOOM_FACTOR = 0.08;
export const FONT_MAX_GAMMA = 0.15;
export const FONT_MIN_GAMMA = 0.03;
export const FONT_THUMBNAILS_UBUFFER_DARK = 0.53;
export const FONT_THUMBNAILS_UBUFFER_LIGHT = 0.49;
export const FONT_THUMBNAILS_DARK_COLOR = '#4B4D63';
export const FONT_UBUFFER_DARK = 0.49;
export const FONT_UBUFFER_LIGHT = 0.45;
export const FONT_UCOLOR = { r: 0, g: 0, b: 0 };
export const FONT_UGAMMA = 0.2;

export const LOCKED_CHAIR_COLOR = '#A9A8B3';
export const THUMBNAIL_LOCKED_CHAIR_COLOR = '#DBDAE3';
export const STROKE_DARK_COEF = 0.92;

export const PROTECTED_CHAIR_COLOR = '#13002D';

export const CHAIR_RADIUS = 15;
export const CHAIR_FONT_SIZE = 15;
export const CHAIR_STROKE_WIDTH = 0.07;
export const CHAIR_RENDER_ORDER = 40;

export const GENERAL_ADMISSION_TEXT_HEIGHT = 1.2 * 28;
export const GENERAL_ADMISSION_ICON_HEIGHT = 1.2 * 36;
export const GENERAL_ADMISSION_TEXT_FONT_SIZE = 20;
export const GENERAL_ADMISSION_ICON_FONT_SIZE = 32;
export const GENERAL_ADMISSION_STROKE_WIDTH = 3;

export const LABEL_SIZES = {
    large: 20,
    medium: 17.5,
    small: 15,
    xlarge: 28,
    xxlarge: 32,
};

export const LINE_THICKNESS = 2;
export const LINE_RENDER_ORDER = 20;

export const REQUESTED_CHAIR_COLOR = '#A9A8B3';

export const SELECTION_GRID_Z = 0;
export const SELECTION_GRID_LINE_THICKNESS = 1.5;
export const SELECTION_GRID_LINE_COLOR = '#000000';
export const SELECTION_GRID_LINE_RENDER_ORDER = 200;
export const SELECTION_GRID_SQUARE_COLOR = '#DBDAE3';
export const SELECTION_GRID_SQUARE_OPACITY = 0.5;

export const STANDARD_LABELS = {
    bathroom: 'Bathroom',
    dance: 'Dance',
    drink: 'Drink',
    exit: 'Exit',
    food: 'Food',
    stage: 'Stage',
};

// R: 194 G: 228 B: 242 (from venue_map_renderer)
export const STENCIL_COLOR = '#c2e4f2';
export const STENCIL_STROKE = '#c2e4f2';
export const STENCIL_STROKE_WIDTH = 0;
export const STENCIL_ICON_FONT_SIZE = 30;
export const STENCIL_TEXT_FONT_SIZE = 26;
export const STENCIL_RENDER_ORDER = 10;
export const STENCIL_ICON_POSITION = { x: 1.0, y: -10.0 };
export const STENCIL_TEXT_POSITION = { x: 0, y: +20 };

export const TABLE_COLOR = '#FFFFFF';
export const TABLE_STROKE = '#CCCCCC';
export const TABLE_STROKE_WIDTH = 0.02;
export const TABLE_RENDER_ORDER = 30;
export const TABLE_RECTANGLE_STROKE_WIDTH = 3;

export const TEXT_Z = 5;
export const TEXT_RENDER_ORDER = 100;

export const THUMBNAIL_FONT_GAMMA = 0.02;
export const THUMBNAIL_STENCIL_TEXT_FIT_MARGIN = 0.05;

export const VENUE_STENCIL_RENDER_ORDER = -10;

export const BIG_NUMBER = 1e20;
export const SMALL_NUMBER = -1e20;

export const MAP_TEMPLATE_OVERLAYS_BACKGROUND_COLOR = '#FFFFFF';

export const RENDER_OPTION_AVAILABILITY = 'renderOptionAvailabilty';
export const RENDER_OPTION_HOLDS = 'renderOptionHolds';
export const RENDER_OPTION_SEAT_LABELS = 'renderOptionSeatLabels';
export const RENDER_OPTION_TIERS_COLORS = 'renderOptionTiersColors';
export const DEFAULT_RENDER_OPTIONS = {
    [RENDER_OPTION_TIERS_COLORS]: true,
    [RENDER_OPTION_SEAT_LABELS]: false,
    [RENDER_OPTION_HOLDS]: true,
    [RENDER_OPTION_AVAILABILITY]: true,
};
